import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService, UserRole } from '@umss/shared/data-access';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const allowed = (route.data?.['roles'] as UserRole[] | undefined) ?? [];
  const token = auth.accessToken;

  if (!token) {
    router.navigateByUrl('/login');
    return false;
  }

  const current = auth.authState().role;

  if (!allowed.length || (current && allowed.includes(current))) return true;

  router.navigateByUrl('/not-authorized');

  return false;
};
